import React from "react"
import { Space, Typography } from "antd"

const { Text } = Typography


const renderBrokerOptionLabel = (name, sponsorId, sponsorsMap) => {
  const sponsorName = sponsorsMap[sponsorId]?.name || sponsorId

  return (
    <Space>
      {name}

      <Text type="secondary">
        ({sponsorName})
      </Text>
    </Space>
  )
}

export default renderBrokerOptionLabel
